import http from "../http-common";

const adminAllOnline = () => {
  return http.get(`/v1/devices/online`);
};

const adminAllNoEnroll = () => {
  return http.get(`/v1/devices/no/enroll`);
};

const adminAll = () => {
  return http.get(`/v1/devices`);
};

const getAll = (loc) => {
  return http.get(`/v1/devices/loc/${loc}`);
};

const getAllNoEnroll = (loc) => {
  return http.get(`/v1/devices/no/enroll/loc/${loc}`);
};

const getAllEnrollers = (loc) => {
  return http.get(`/v1/devices/enrollers/loc/${loc}`);
};

const adminAllEnrollers = (loc) => {
  return http.get(`/v1/devices/enrollers`);
};

const adminAllWriters = () => {
  return http.get(`/v1/devices/writers`);
};

const getAllWriters = (loc) => {
  return http.get(`/v1/devices/writers/loc/${loc}`);
};

const adminAllRooms = () => {
  return http.get(`/v1/devices/rooms`);
};

const getAllRooms = (loc) => {
  return http.get(`/v1/devices/rooms/loc/${loc}`);
};

const adminAllElevatorDevices = () => {
  return http.get(`/v1/devices/elevators`);
};

const adminAllAccessDevices = () => {
  return http.get(`/v1/devices/access`);
};

const getAllAccessDevices = (loc) => {
  return http.get(`/v1/devices/access/loc/${loc}`);
};

const get = (id) => {
  return http.get(`/v1/devices/${id}`);
};

const create = (data) => {
  return http.post("/v1/devices", data);
};

const update = (id, data) => {
  return http.put(`/v1/devices/${id}`, data);
};

const updateByMac = (mac, data) => {
  return http.put(`/v1/devices/status/${mac}`, data);
};

const getByMac = (mac) => {
  return http.get(`/v1/devices/status/${mac}`);
};

const remove = (id) => {
  return http.delete(`/v1/devices/${id}`);
};

const removeAll = () => {
  return http.delete(`/v1/devices`);
};

const findByIpAddress = (ip_address) => {
  return http.get(`/v1/devices?ip_address=${ip_address}`);
};

const findAllOnline = (loc) => {
  return http.get(`/v1/devices/online/loc/${loc}`);
};

const getDevicesWithFloors = (loc) => {
  return http.get(`/v1/devices/with-floors`);
};

const updateDeviceFloor = (deviceId, floorId) => {
  return http.put(`/v1/devices/${deviceId}/floor`, { floorId });
};

const discover = () => {
  return http.post(`/v1/devices/discover`);
};

const mapDevice = (data) => {
  return http.post(`/v1/devices/map`, data);
};

const replaceDevice = (id, data) => {
  return http.post(`/v1/devices/${id}/replace`, data);
};

const adminAllWaterleakDevices = () => {
  return http.get(`/v1/devices/waterleak`);
};

const getAllWaterleakDevices = (loc) => {
  return http.get(`/v1/devices/waterleak/loc/${loc}`);
};

export default {
  getAll,
  getAllWriters,
  getAllRooms,
  getAllAccessDevices,
  getAllWaterleakDevices,
  get,
  getByMac,
  create,
  update,
  updateByMac,
  remove,
  removeAll,
  findByIpAddress,
  findAllOnline,
  adminAllOnline,
  adminAll,
  adminAllWriters,
  adminAllNoEnroll,
  getAllNoEnroll,
  getAllEnrollers,
  adminAllEnrollers,
  adminAllRooms,
  adminAllAccessDevices,
  adminAllElevatorDevices,
  adminAllWaterleakDevices,
  getDevicesWithFloors,
  updateDeviceFloor,
  discover,
  mapDevice,
  replaceDevice,
};
